import React, { useEffect } from 'react';
import { WindowContainer, RouteContainer } from './containers';
import api from './components/api';
import { Component, AppDefinition } from './types';
import { trackPage } from 'pwa-synergy-umami';

export interface SynergyAppProps<T extends object> {
  appName: string;
  components: Component<T>[];
  titleBar?: (commands: T) => JSX.Element;
  toolBar?: (commands: T) => JSX.Element;
  statusBar?: (commands: T) => JSX.Element;
  desktopApp: AppDefinition<T>;
  mobileApp: AppDefinition<T>;
}

const SynergyApp = <T extends object>(props: SynergyAppProps<T>) => {
  const { components, titleBar, toolBar, statusBar, desktopApp, mobileApp } = props;

  useEffect(() => {
    trackPage({
      url: '/',
      title: `Router-${api.isMobile() ? 'Mobile' : 'Desktop'}`,
    });
  }, []);

  const componentMap = new Map(
    components.map((component: Component<T>) => [component.id, component]),
  );

  const component = (app: AppDefinition<T>): JSX.Element => {
    return app.type === 'Route' ? (
      <RouteContainer
        titleBar={titleBar}
        toolBar={toolBar}
        statusBar={statusBar}
        components={componentMap}
        commands={app.commands}
        hideTitleBar={app.hideTitleBar}
        hideToolBar={app.hideToolBar}
        hideStatusBar={app.hideStatusBar}
        routes={app.routes}
        routeNotFoundComponent={app.routeNotFoundComponent}
      />
    ) : (
      <WindowContainer
        titleBar={titleBar}
        toolBar={toolBar}
        statusBar={statusBar}
        components={componentMap}
        commands={app.commands}
        hideTitleBar={app.hideTitleBar}
        hideToolBar={app.hideToolBar}
        hideStatusBar={app.hideStatusBar}
        layout={app.layout}
      />
    );
  };

  return <>{api.isMobile() ? component(mobileApp) : component(desktopApp)}</>;
};

export default SynergyApp;
